webpackJsonp([62],{

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationInvoice_vue__ = __webpack_require__(735);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7545c388_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationInvoice_vue__ = __webpack_require__(916);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7545c388_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/shop/reservations";

/* harmony default export */ __webpack_exports__["a"] = ({
  getById: function getById(id) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + id).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/create", request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  uploadSignage: function uploadSignage(payload) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/signage", payload).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  updateSignage: function updateSignage(reservationId, payload) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/" + reservationId + "/signage", payload).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  deleteSignage: function deleteSignage(reservationId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + "/" + reservationId + "/signage").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  cancel: function cancel(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/cancel", request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  postFeedback: function postFeedback(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/feedback", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  postNotes: function postNotes(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/note", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  repricing: function repricing(reservationId) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-detail").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getAvailableAncillaries: function getAvailableAncillaries(reservationId) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/ancillaries").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  submitRepricing: function submitRepricing(reservationId, payload) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/" + reservationId + "/reprice", payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  getRepricingHistory: function getRepricingHistory(reservationId) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-history").then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  getRepricingLog: function getRepricingLog(reservationId, id) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + reservationId + "/repricing-log/" + id).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  closeReservation: function closeReservation(reservationId) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/" + reservationId + "/close").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  }
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/shop/payments";

/* harmony default export */ __webpack_exports__["a"] = ({
  amendPayUrl: function amendPayUrl(url, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://prod-gateway-opsicar.idteknologia.net" + ("/" + url), payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  amendPayCredit: function amendPayCredit(param) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/amend/pay/credit?" + param)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  generateUrl: function generateUrl(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/url", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  payWithDeposit: function payWithDeposit(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/deposit", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  payWithInvoice: function payWithInvoice(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/invoice", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  payWithCredit: function payWithCredit(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/credit" + request)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  payOutstandingAmount: function payOutstandingAmount(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/credit_card/addon", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  rdpFirstPhase: function rdpFirstPhase(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/reddot/firstphase", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  payPalCaptureOrder: function payPalCaptureOrder(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/paypal/capture", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  payReservation: function payReservation(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/credit_card", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/deposits';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  setMinimumBalance: function setMinimumBalance(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/threshold', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  suspend: function suspend(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/suspend', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  inquiryDeduct: function inquiryDeduct(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/deduct/inquiry', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  inquiryRepriceDeduct: function inquiryRepriceDeduct(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/deduct/inquiry/price', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/job/provider';

/* harmony default export */ __webpack_exports__["a"] = ({
  countAll: function countAll(period, mode) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/count?period=' + period + '&mode=' + mode)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAll: function getAll(filter) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getDetail: function getDetail(reservationId) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/detail/' + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getPreferredVehicles: function getPreferredVehicles(reservationId) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/vehicle/' + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getPreferredDrivers: function getPreferredDrivers(reservationId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/driver/' + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  confirmProvider: function confirmProvider(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/confirm', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  declineProvider: function declineProvider(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/decline', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  assignVehicle: function assignVehicle(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/vehicle/assign', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  releaseVehicle: function releaseVehicle(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/vehicle/release', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt('return', _context9.sent);

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  manualDispatchDriver: function manualDispatchDriver(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/driver/dispatch', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt('return', _context10.sent);

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  releaseDriver: function releaseDriver(request) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/driver/release', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt('return', _context11.sent);

            case 3:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  addPostbookingAncillary: function addPostbookingAncillary(request) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/extraservice', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context12.abrupt('return', _context12.sent);

            case 3:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  updatePostbookingAncillary: function updatePostbookingAncillary(request) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/provider/extraservice', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context13.abrupt('return', _context13.sent);

            case 3:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  deletePostbookingAncillary: function deletePostbookingAncillary(id) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/provider/extraservice/' + id).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context14.abrupt('return', _context14.sent);

            case 3:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  proposePrice: function proposePrice(object) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/propose', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context15.abrupt('return', _context15.sent);

            case 3:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  approvePrice: function approvePrice(object) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/approve', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context16.abrupt('return', _context16.sent);

            case 3:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  proposePriceReject: function proposePriceReject(object) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/proposereject', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context17.abrupt('return', _context17.sent);

            case 3:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  repricePostbookingAncillary: function repricePostbookingAncillary(object) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/price', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context18.abrupt('return', _context18.sent);

            case 3:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  },
  publishInvoice: function publishInvoice(object) {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/invoice', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context19.abrupt('return', _context19.sent);

            case 3:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19);
    }))();
  },
  closeReservation: function closeReservation(object) {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/close', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context20.abrupt('return', _context20.sent);

            case 3:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20);
    }))();
  },
  rescueReservation: function rescueReservation(object) {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/provider/rescue', object).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context21.abrupt('return', _context21.sent);

            case 3:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21);
    }))();
  },
  viewAttachment: function viewAttachment(id) {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/provider/attach/' + id)).then(function (response) {
                return response.data;
              });

            case 2:
              return _context22.abrupt('return', _context22.sent);

            case 3:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22);
    }))();
  }
});

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_shop_reservation_inquiryReservationService_js__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_job_providerJob_inquiryProviderJobService_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_shop_paymentService_js__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_deposit_depositSummaryService_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_setting_settingService_js__ = __webpack_require__(255);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      moneyFormat: null,
      detail: {},
      rentDays: null,
      isLoading: false,
      msg: "Please wait",
      reservationDetail: {
        booker: {},
        serviceType: "",
        code: "",
        reservationDate: {},
        passengers: [],
        pickUpDate: {},
        pickUpLocation: {},
        dropOffDate: {},
        dropOffLocation: {},
        className: "",
        paymentStatus: "",
        currencyCode: "",
        grandTotal: "",
        histories: [],
        fareComponents: [],
        fareComponentsSelling: [],
        fareComponentsBuying: [],
        fareComponentsPreBooking: [],
        fareComponentsPostBooking: []
      },
      totalCost: 0,
      remainingPayment: 0
    };
  },

  computed: {
    isDetailExist: function isDetailExist() {
      return this.detail !== null && this.detail !== undefined;
    },
    hasPaid: function hasPaid() {
      return this.isDetailExist && this.detail.paymentStatus !== undefined && this.detail.paymentStatus !== null && (this.detail.paymentStatus.toLowerCase() === "complete" || this.detail.remainingPayment === 0);
    },
    pickUpLocation: function pickUpLocation() {
      return this.isDetailExist && this.detail.pickUpLocation !== undefined && this.detail.pickUpLocation !== null ? this.detail.pickUpLocation.name : "";
    },
    dropOffLocation: function dropOffLocation() {
      return this.isDetailExist && this.detail.dropOffLocation !== undefined && this.detail.dropOffLocation !== null && this.detail.dropOffLocation.name !== this.pickUpLocation ? this.detail.dropOffLocation.name : "Same Location";
    },
    pickUpTime: function pickUpTime() {
      return this.isDetailExist && this.detail.pickUpDate.hour + ":" + (this.detail.pickUpDate.minute < 10 ? this.detail.pickUpDate.minute + "0" : this.detail.pickUpDate.minute);
    },
    dropOffTime: function dropOffTime() {
      return this.isDetailExist && this.detail.dropOffDate.hour + ":" + (this.detail.dropOffDate.minute < 10 ? this.detail.dropOffDate.minute + "0" : this.detail.dropOffDate.minute);
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.isDetailExist && this.detail.serviceType !== "" && this.detail.serviceType.toLowerCase() === "airporttransfer";
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getById();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getById: function getById() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fareComponents, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__services_shop_reservation_inquiryReservationService_js__["a" /* default */].getById(_this2.$route.params.id);

              case 4:
                _this2.detail = _context2.sent;

                _this2.rentDays = _this2.detail.rentDays;
                _this2.moneyFormat = _this2.detail.moneyFormat;
                if (_this2.detail != null) {
                  _this2.reservationDetail.booker = _this2.detail.booker;
                  _this2.reservationDetail.histories = _this2.detail.histories;
                  _this2.reservationDetail.pickUpLocation = _this2.detail.pickUpLocation;
                  _this2.reservationDetail.dropOffLocation = _this2.detail.dropOffLocation;
                  _this2.reservationDetail.pickUpDate = _this2.detail.pickUpDate;
                  _this2.reservationDetail.dropOffDate = _this2.detail.dropOffDate;
                  _this2.reservationDetail.code = _this2.detail.code;
                  _this2.reservationDetail.className = _this2.detail.className;
                  _this2.reservationDetail.serviceType = _this2.detail.serviceType;
                  _this2.reservationDetail.reservationDate = _this2.detail.reservationDate;
                  _this2.reservationDetail.passengers = _this2.detail.passengers;
                  _this2.reservationDetail.paymentStatus = _this2.detail.paymentStatus;
                  _this2.reservationDetail.currencyCode = _this2.detail.currencyCode;
                  _this2.reservationDetail.grandTotal = _this2.detail.grandTotal;
                  _this2.reservationDetail.bookingTotal = _this2.detail.bookingTotal;
                  _this2.reservationDetail.histories = _this2.detail.histories;
                  _this2.reservationDetail.fareComponents = _this2.detail.fareComponents;
                  if (_this2.reservationDetail.fareComponents != null && _this2.reservationDetail.fareComponents.length > 0) {
                    fareComponents = Array.prototype.slice.call(_this2.reservationDetail.fareComponents, 0);

                    _this2.reservationDetail.fareComponentsPreBooking = fareComponents.filter(function (f) {
                      return f.category == "Selling" && f.isPreBooking == true;
                    });
                    _this2.reservationDetail.fareComponentsPostBooking = fareComponents.filter(function (f) {
                      return f.category == "Selling" && f.isPreBooking == false;
                    });
                  }
                  _this2.calculateTotal();
                }
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context2.prev = 13;

                _this2.isLoading = false;
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    calculateTotal: function calculateTotal() {
      this.remainingPayment = this.reservationDetail.fareComponentsPostBooking.reduce(function (accum, item) {
        return accum + item.quantity * item.rate;
      }, 0);
      this.totalCost = this.reservationDetail.grandTotal + this.remainingPayment;
    },
    payWithDeposit: function payWithDeposit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  _this3.isLoading = true;
                  // TODO
                } catch (error) {
                  if (error.errors) {
                    for (index = 0; index < error.errors.length; index++) {
                      _this3.$notification.error(error.errors[index], { title: "Error" });
                    }
                  }
                } finally {
                  _this3.isLoading = false;
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    payWithCreditCard: function payWithCreditCard() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                try {
                  _this4.isLoading = true;
                  // TODO
                } catch (error) {
                  if (error.errors) {
                    for (index = 0; index < error.errors.length; index++) {
                      _this4.$notification.error(error.errors[index], { title: "Error" });
                    }
                  }
                } finally {
                  _this4.isLoading = false;
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },

    // async openRDP() {
    //   try {
    //     this.isLoading = true;
    //     const summaryUrl = `${document.location.origin}/distribution/inquiry-reservation/${this.detail.id}`;
    //     const notifyUrl = `${process.env.VUE_APP_BASE_API}/api/shop/payments/public/reddot/notify`;
    //     const response = await paymentService.rdpFirstPhase({
    //       reservationId: this.detail.id,
    //       reservationCode: this.detail.code,
    //       totalAmount: this.detail.remainingPayment,
    //       notifyUrl: notifyUrl,
    //       redirectUrl: summaryUrl,
    //       backUrl: summaryUrl,
    //       currencyCode: this.detail.currencyCode,
    //     });
    //     if (response && response.isSuccess) {
    //       window.open(response.data.payment_url, "_self");
    //     } else {
    //       this.$notification.error("Failed redirecting to payment page.");
    //     }
    //   } catch (error) {
    //     if (error.errors) {
    //       for (let index = 0; index < error.errors.length; index++) {
    //         this.$notification.error(error.errors[index], { title: "Error" });
    //       }
    //     }
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    printMoney: function printMoney(value) {
      return this.moneyFormat ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(value).format(this.moneyFormat.decimalFormat) : value;
    },
    publishInvoice: function publishInvoice(value) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_job_providerJob_inquiryProviderJobService_js__["a" /* default */].publishInvoice({
                  inquiryReservationId: _this5.detail.id,
                  providerId: _this5.detail.providerId
                });

              case 4:
                response = _context5.sent;

                _this5.$notification.success("Successfully Invoiced", {
                  title: "Success"
                });
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context5.prev = 11;

                _this5.isLoading = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8, 11, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ 916:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('section',{staticClass:"reservation-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"header--reservation-detail"},[_c('div',{staticClass:"header--reservation-box"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb mb-35 pz"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/report/inquiry-reservation"}},[_vm._v("\n                      Manage Booking\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                    Invoice\n                  ")])])]),_vm._v(" "),_c('h4',[_vm._v("Booking Detail")]),_vm._v(" "),_c('div',{staticClass:"table-legend"},[_c('ul',[(_vm.isAirportTransfer)?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Payment Status")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',{class:{
                    '--green35': _vm.detail.paymentStatus === 'Complete',
                    'sts-danger': _vm.detail.paymentStatus !== 'Complete',
                  }},[_vm._v(_vm._s(_vm.detail.paymentStatus))])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Code")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.detail.code))])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Date")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.detail.reservationDate.stringFullDate)+" ")])])])]),_vm._v(" "),_c('div',{staticClass:"body--reservation-detail"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-businessmen pull-left mr-10"}),_vm._v(" "),_c('h4',[_vm._v("Bookers")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.booker.title)+". "+_vm._s(_vm.detail.booker.fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    (+"+_vm._s(_vm.detail.booker.phoneCode)+")\n                    "+_vm._s(_vm.detail.booker.phoneNumber)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v(_vm._s(_vm.detail.booker.email))])]),_vm._v(" "),(
                    _vm.detail.booker.residentAddress !== undefined &&
                    _vm.detail.booker.residentAddress !== null
                  )?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Resident Address")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.booker.residentAddress)+"\n                  ")])]):_vm._e(),_vm._v(" "),(
                    _vm.detail.booker.identityNumber !== undefined &&
                    _vm.detail.booker.identityNumber !== null
                  )?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("ID Card")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.booker.identityNumber)+"\n                  ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 divider-left text-right"},[_c('h4',[_vm._v("Passenger Information")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.passengers[0].title)+".\n                    "+_vm._s(_vm.detail.passengers[0].fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    (+"+_vm._s(_vm.detail.passengers[0].phoneCode)+")\n                    "+_vm._s(_vm.detail.passengers[0].phoneNumber)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.passengers[0].email)+"\n                  ")])]),_vm._v(" "),(
                    _vm.detail.passengers[0].location !== undefined &&
                    _vm.detail.passengers[0].location !== null
                  )?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Resident Address")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.passengers[0].location.address)+"\n                  ")])]):_vm._e(),_vm._v(" "),(
                    _vm.detail.passengers[0].identityNumber !== undefined &&
                    _vm.detail.passengers[0].identityNumber !== null
                  )?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("ID Card")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.detail.passengers[0].identityNumber)+"\n                  ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"box-addons mt-20"},[_c('div',{staticClass:"panel-group",attrs:{"id":"accordion"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading text-center"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.publishInvoice()}}},[_vm._v("Publish")])])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"price-detail-header"},[_c('div',{staticClass:"grand-total"},[_c('table',{staticClass:"table table-amount"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Base")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.detail.baseFare))+"\n                    ")])]),_vm._v(" "),(_vm.detail.surchargeTotal > 0)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Surcharge")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.detail.surchargeTotal))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.detail.ancillaryTotal > 0)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Ancillary")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.detail.ancillaryTotal))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.detail.ancillaryTotal > 0)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.detail.bookingTotal))+"\n                    ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"reservation-button"},[(!_vm.hasPaid)?_c('div',{staticClass:"dropdown"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenu1"}},[_c('li',[(_vm.detail.paymentConfig.isEnableCorporateAccount)?_c('a',{on:{"click":function($event){return _vm.payWithDeposit()}}},[_vm._v("\n                        Corporate Account\n                      ")]):_vm._e(),_vm._v(" "),(_vm.detail.paymentConfig.isEnablePaymentGateway)?_c('a',{on:{"click":function($event){return _vm.payWithCreditCard()}}},[_vm._v("\n                        Credit Card\n                      ")]):_vm._e()])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"grand-total"},[_c('table',{staticClass:"table table-amount"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.reservationDetail.fareComponentsPostBooking),function(item){return _c('tr',{key:item.name},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(item.quantity * item.rate))+"\n                    ")])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Sub Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                      "+_vm._s(_vm.printMoney(_vm.remainingPayment))+"\n                    ")])])],2)]),_vm._v(" "),_c('div',{staticClass:"reservation-button"},[(!_vm.hasPaid)?_c('div',{staticClass:"dropdown"},[_vm._m(4),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenu1"}},[_c('li',[(_vm.detail.paymentConfig.isEnableCorporateAccount)?_c('a',{on:{"click":function($event){return _vm.payWithDeposit()}}},[_vm._v("Corporate Account")]):_vm._e(),_vm._v(" "),(_vm.detail.paymentConfig.isEnablePaymentGateway)?_c('a',{on:{"click":function($event){return _vm.payWithCreditCard()}}},[_vm._v("Credit Card")]):_vm._e()])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"reservation-summary--small"},[_c('div',{staticClass:"dropandpickup cRow"},[_c('div',{staticClass:"col-sm-6 plz"},[_c('div',{staticClass:"location-pick-up",attrs:{"title":_vm.pickUpLocation}},[_vm._v("\n                  "+_vm._s(_vm.pickUpLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                      "+_vm._s(_vm.detail.pickUpDate.stringDate)+"\n                      "+_vm._s(_vm.detail.pickUpDate.stringShortMonth)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                      "+_vm._s(_vm.pickUpTime)+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 prz divider-left"},[_c('div',{staticClass:"location-drop-off text-right",attrs:{"title":_vm.dropOffLocation}},[_vm._v("\n                  "+_vm._s(_vm.dropOffLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                      "+_vm._s(_vm.detail.dropOffDate.stringDate)+"\n                      "+_vm._s(_vm.detail.dropOffDate.stringShortMonth)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                      "+_vm._s(_vm.dropOffTime)+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"type-car"},[_vm._v(_vm._s(_vm.detail.className))]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"price-summary"},[_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"},[_c('div',{staticClass:"label-price"},[(_vm.isAirportTransfer)?_c('span',[_vm._v("Price")]):_c('span',[_vm._v("Price for "+_vm._s(_vm.rentDays))])]),_vm._v(" "),_c('div',{staticClass:"price-value"},[_vm._v("\n                    "+_vm._s(_vm.detail.currencyCode)+"\n                    "),_vm._v("\n                    "+_vm._s(_vm.printMoney(_vm.detail.grandTotal + _vm.remainingPayment))+"\n                  ")])])])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary hidden",on:{"click":function($event){return _vm.confirm()}}},[_vm._v("CONFIRM")])])])])]):_vm._e(),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"collapse1"}},[_c('div',{staticClass:"panel-body"},[_c('p',[_vm._v("\n                      Lorem ipsum dolor sit, amet consectetur adipisicing\n                      elit. Assumenda iusto doloremque cum ullam sit deleniti\n                      perferendis praesentium facilis mollitia eveniet ipsam,\n                      provident commodi voluptas voluptatum, modi consequatur.\n                      Deleniti, perspiciatis sapiente.\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_c('span',[_c('i',{staticClass:"ic-wallet mr-5 --blue"})]),_vm._v(" "),_vm._v("\n                      Pre-Booking\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","id":"dropdownMenu1","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_vm._v("\n                    Pay now\n                    "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_c('span',[_c('i',{staticClass:"ic-wallet mr-5 --blue"})]),_vm._v("\n                      Extra Services\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","id":"dropdownMenu1","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_vm._v("\n                    Pay now\n                    "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"capacity-seat"},[_vm._v("Pax Capacity")]),_vm._v(" "),_c('div',{staticClass:"capacity-baggage"},[_vm._v("Max-Baggage")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"operation with-driver"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/62.c4666612e93c39b015e6.js